module.exports = __webpack_public_path__ + "media/images/indeed-transparent-logo-493f1c2c7f50cf7668aeb029066a7477.png";